import Faq from 'models/Faq';
import { createAsyncAction } from 'typesafe-actions';

export const getFaqs = createAsyncAction('GET_FAQS', 'GET_FAQS_SUCCEEDED', 'GET_FAQS_FAILURE')<
  undefined,
  Faq[],
  undefined
>();
